export default __webpack_public_path__ + "images/9fb17477794a88094df936c0b10d6bbc-food_and_drink_tablet.webp";